// import App from '../../app';

import AnimationController from './animation';
import ScrollController from './scroll';
import ResizeController from './resize';

import { getRootOffset } from '../helpers';

class SkrolliteController {

	animation = null;

	viewport = null;

	skrollites = [];

	scroll = 0;

	initialize() {
		this.viewport = window.innerHeight;
		this.addEventListeners();
	}

	addEventListeners() {
		ResizeController.add(this.#onWindowResize);
	}

	removeEventListeners() {
		ResizeController.remove(this.#onWindowResize);
	}

	#onWindowResize = () => {
		this.gather();
		this.measure();
	}

	clear() {
		this.skrollites = [];
	}

	measure() {
		for (const skrollite of this.skrollites) {
			skrollite.height = skrollite.el.offsetHeight;
			skrollite.offset = getRootOffset(skrollite.el).top;
		}
	}

	refresh() {
		this.stop();
		this.gather();
		this.measure();
		this.start();
	}

	adjust() {
		this.measure();
		this.updateSkrollites();
	}

	gather() {
		this.clear();
		const skrollites = document.querySelectorAll('[data-skrollite]');
		for (const el of skrollites) {
			this.skrollites.push({
				el,
				height: 0,
				offset: 0,
				update: false
			});
		}
	}

	updateSkrollites() {
		for (let i = 0, l = this.skrollites.length; i < l; ++i) {
			if (this.scroll + this.viewport * 0.8 > this.skrollites[i].offset) {
				this.skrollites[i].update = true;
			}
		}
	}

	renderSkrollites() {
		for (let i = 0, l = this.skrollites.length; i < l; ++i) {
			const skrollite = this.skrollites[i];
			if (skrollite.update) {
				skrollite.update = false;
				skrollite.el.dataset.inViewport = true;
				this.skrollites.splice(i, 1);
				--l;
			}
		}
	}

	start() {
		this.animation = AnimationController.set({
			update: this.#update,
			render: this.#render
		});
	}

	stop() {
		if (this.animation) {
			AnimationController.clear(this.animation);
			this.animation = null;
		}
	}

	#update = () => {
		if (ScrollController.eased !== this.scroll) {
			this.scroll = ScrollController.eased;
			this.updateSkrollites();
			return true;
		}
	}

	#render = () => {
		this.renderSkrollites();
	}

}

export default new SkrolliteController();
